export default {
  mapLeftClick: {
    placeInfo: 'Place info',
    placeInsidePolygon: 'Place inside polygon',
    polygonArea: 'Polygon area',
    copyLnglat: 'Copy lng, lat',
    copyLatlng: 'Copy lat, lng',
    directionsToClickedPoint: 'Directions to clicked place',
    lnglatCopied: 'Longitude and latitude copied',
    latlngCopied: 'Latitude and longitude copied'
  }
}
